import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-674ba150"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TUI-contact-left" }
const _hoisted_2 = { class: "TUI-contact-left-header" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "plus" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "search-box"
}
const _hoisted_6 = { class: "input-box" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "TUI-contact-column"
}
const _hoisted_9 = { class: "TUI-contact-column-item" }
const _hoisted_10 = {
  key: 0,
  class: "num"
}
const _hoisted_11 = {
  key: 0,
  class: "TUI-contact-list"
}
const _hoisted_12 = { class: "TUI-contact-list-item selected not-aside" }
const _hoisted_13 = {
  key: 0,
  class: "num"
}
const _hoisted_14 = { class: "TUI-contact-column-item" }
const _hoisted_15 = { class: "TUI-contact-list" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "left" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "content" }
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "ID" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ID：", -1))
const _hoisted_23 = { class: "type" }
const _hoisted_24 = { class: "TUI-contact-column-item" }
const _hoisted_25 = { class: "TUI-contact-list" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "left" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "content" }
const _hoisted_30 = { class: "name" }
const _hoisted_31 = {
  key: 1,
  class: "TUI-contact-list"
}
const _hoisted_32 = { class: "left" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "content" }
const _hoisted_35 = { class: "name" }
const _hoisted_36 = { class: "ID" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ID：", -1))
const _hoisted_38 = { class: "type" }
const _hoisted_39 = { class: "TUI-contact-main" }
const _hoisted_40 = {
  key: 0,
  class: "TUI-contact-main-h5-title"
}
const _hoisted_41 = {
  key: 1,
  class: "TUI-contact-main-info"
}
const _hoisted_42 = { class: "TUI-contact-main-info-header" }
const _hoisted_43 = { class: "list" }
const _hoisted_44 = ["src"]
const _hoisted_45 = {
  key: 0,
  class: "TUI-contact-main-info-main"
}
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "TUI-contact-main-info-footer" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  key: 2,
  class: "TUI-contact-main-info"
}
const _hoisted_51 = { class: "TUI-contact-main-info-header" }
const _hoisted_52 = { class: "list" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ID：", -1))
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "TUI-contact-main-info-footer" }
const _hoisted_56 = {
  key: 3,
  class: "TUI-contact-system"
}
const _hoisted_57 = {
  key: 0,
  class: "TUI-contact-system-header"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageSystem = _resolveComponent("MessageSystem")!

  return (_openBlock(), _createBlock(_Transition, { onBeforeLeave: _ctx.init }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["TUI-contact", [_ctx.env.isH5 ? 'TUI-contact-H5' : '']])
      }, [
        _createElementVNode("aside", _hoisted_1, [
          _createElementVNode("header", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!_ctx.isSearch)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "search-box",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)))
                  }, [
                    _hoisted_4,
                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('TUIContact.添加群聊')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchID) = $event)),
                        placeholder: _ctx.$t('TUIContact.输入群ID，按回车搜索'),
                        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleSearchGroup && _ctx.handleSearchGroup(...args)), ["enter"])),
                        enterkeyhint: "search"
                      }, null, 40, _hoisted_7), [
                        [_vModelText, _ctx.searchID]
                      ]),
                      (!!_ctx.searchID)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "icon icon-cancel",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchID = ''))
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", {
                      class: "search-cancel",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)))
                    }, _toDisplayString(_ctx.$t('取消')), 1)
                  ]))
            ])
          ]),
          (!_ctx.isSearch)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                _createElementVNode("li", _hoisted_9, [
                  _createElementVNode("header", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.select('system')))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon icon-right", [_ctx.columnName === 'system' && 'icon-down']])
                    }, null, 2),
                    _createElementVNode("main", null, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUIContact.群聊通知')), 1),
                      (_ctx.systemConversation && _ctx.systemConversation.unreadCount > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.systemConversation.unreadCount), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.columnName === 'system')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                        _createElementVNode("li", _hoisted_12, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUIContact.系统通知')), 1),
                          (_ctx.systemConversation && _ctx.systemConversation.unreadCount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.systemConversation.unreadCount), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("li", _hoisted_14, [
                  _createElementVNode("header", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.select('group')))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon icon-right", [_ctx.columnName === 'group' && 'icon-down']])
                    }, null, 2),
                    _createElementVNode("main", null, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUIContact.我的群聊')), 1)
                    ])
                  ]),
                  _withDirectives(_createElementVNode("ul", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["TUI-contact-list-item", [_ctx.currentGroup?.groupID === item?.groupID && 'selected']]),
                        key: index,
                        onClick: ($event: any) => (_ctx.handleListItem(item))
                      }, [
                        _createElementVNode("aside", _hoisted_17, [
                          _createElementVNode("img", {
                            class: "avatar",
                            src: 
                      item?.avatar ||
                      'https://sdk-web-1252463788.cos.ap-hongkong.myqcloud.com/im/demo/TUIkit/web/img/constomer.svg'
                    ,
                            onerror: "this.src='https://sdk-web-1252463788.cos.ap-hongkong.myqcloud.com/im/demo/TUIkit/web/img/constomer.svg'"
                          }, null, 8, _hoisted_18)
                        ]),
                        _createElementVNode("main", _hoisted_19, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", _hoisted_20, _toDisplayString(item?.name), 1),
                            _createElementVNode("li", _hoisted_21, [
                              _hoisted_22,
                              _createElementVNode("span", null, _toDisplayString(item?.groupID), 1)
                            ])
                          ]),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(item?.type), 1)
                        ])
                      ], 10, _hoisted_16))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.columnName === 'group']
                  ])
                ]),
                _createElementVNode("li", _hoisted_24, [
                  _createElementVNode("header", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.select('friend')))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon icon-right", [_ctx.columnName === 'friend' && 'icon-down']])
                    }, null, 2),
                    _createElementVNode("main", null, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUIContact.我的好友')), 1)
                    ])
                  ]),
                  _withDirectives(_createElementVNode("ul", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.friendList, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["TUI-contact-list-item", [_ctx.currentFriend?.userID === item?.userID && 'selected']]),
                        key: index,
                        onClick: ($event: any) => (_ctx.handleListItem(item))
                      }, [
                        _createElementVNode("aside", _hoisted_27, [
                          _createElementVNode("img", {
                            class: "avatar",
                            src: item?.profile?.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
                            onerror: "this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
                          }, null, 8, _hoisted_28),
                          (_ctx.displayOnlineStatus)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["online-status", 
                      _ctx.userStatusList.get(item?.userID)?.statusType === 1
                        ? 'online-status-online'
                        : 'online-status-offline'
                    ])
                              }, null, 2))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("main", _hoisted_29, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", _hoisted_30, _toDisplayString(item?.profile?.nick || item?.userID), 1)
                          ])
                        ])
                      ], 10, _hoisted_26))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.columnName === 'friend']
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                (!!_ctx.searchGroup?.groupID)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      class: _normalizeClass(["TUI-contact-list-item", [_ctx.currentGroup?.groupID === _ctx.searchGroup?.groupID && 'selected']]),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleListItem(_ctx.searchGroup)))
                    }, [
                      _createElementVNode("aside", _hoisted_32, [
                        _createElementVNode("img", {
                          class: "avatar",
                          src: 
                  _ctx.searchGroup?.avatar ||
                  'https://sdk-web-1252463788.cos.ap-hongkong.myqcloud.com/im/demo/TUIkit/web/img/constomer.svg'
                ,
                          onerror: "this.src='https://sdk-web-1252463788.cos.ap-hongkong.myqcloud.com/im/demo/TUIkit/web/img/constomer.svg'"
                        }, null, 8, _hoisted_33)
                      ]),
                      _createElementVNode("main", _hoisted_34, [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", _hoisted_35, _toDisplayString(_ctx.searchGroup?.name), 1),
                          _createElementVNode("li", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("span", null, _toDisplayString(_ctx.searchGroup?.groupID), 1)
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.searchGroup?.type), 1)
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _withDirectives(_createElementVNode("main", _hoisted_39, [
          (_ctx.env.isH5)
            ? (_openBlock(), _createElementBlock("header", _hoisted_40, [
                _createElementVNode("i", {
                  class: "icon icon-back",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
                }),
                _createElementVNode("h1", null, _toDisplayString(_ctx.currentGroup?.name || _ctx.$t('TUIContact.系统通知')), 1)
              ]))
            : _createCommentVNode("", true),
          (!!_ctx.currentGroup?.groupID)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("header", _hoisted_42, [
                  _createElementVNode("ul", _hoisted_43, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.currentGroup?.name), 1),
                    _createElementVNode("li", null, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUIContact.群ID')) + "：", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.currentGroup?.groupID), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUIContact.群类型')) + "：", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.currentGroup?.type), 1)
                    ])
                  ]),
                  _createElementVNode("img", {
                    class: "avatar",
                    src: _ctx.currentGroup?.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/group_avatar.png',
                    onerror: "this.src='https://sdk-web-1252463788.cos.ap-hongkong.myqcloud.com/im/demo/TUIkit/web/img/constomer.svg'"
                  }, null, 8, _hoisted_44)
                ]),
                (_ctx.isNeedPermission)
                  ? (_openBlock(), _createElementBlock("main", _hoisted_45, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUIContact.请填写验证信息')), 1),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentGroup.applyMessage) = $event)),
                        disabled: _ctx.currentGroup.apply
                      }, null, 8, _hoisted_46), [
                        [_vModelText, _ctx.currentGroup.applyMessage]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("footer", _hoisted_47, [
                  (_ctx.currentGroup.apply && _ctx.currentGroup.type === 'AVChatRoom')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.$t('TUIContact.已加入')), 1))
                    : (_ctx.currentGroup.apply)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(_ctx.$t('TUIContact.已申请')), 1))
                      : (_ctx.isNeedPermission)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "btn btn-default",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.join(_ctx.currentGroup)))
                          }, _toDisplayString(_ctx.$t('TUIContact.申请加入')), 1))
                        : (!_ctx.currentGroup.selfInfo.userID)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              class: "btn btn-default",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.join(_ctx.currentGroup)))
                            }, _toDisplayString(_ctx.$t('TUIContact.加入群聊')), 1))
                          : (
                _ctx.currentGroup.selfInfo.userID &&
                _ctx.currentGroup.selfInfo.role === 'Owner' &&
                _ctx.currentGroup.type !== 'Private'
              )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                class: "btn btn-cancel",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dismiss(_ctx.currentGroup)))
                              }, _toDisplayString(_ctx.$t('TUIContact.解散群聊')), 1))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 5,
                                class: "btn btn-cancel",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.quit(_ctx.currentGroup)))
                              }, _toDisplayString(_ctx.$t('TUIContact.退出群聊')), 1)),
                  (_ctx.currentGroup.selfInfo.userID)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 6,
                        class: "btn btn-default",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.enter(_ctx.currentGroup.groupID, 'GROUP')))
                      }, _toDisplayString(_ctx.$t('TUIContact.进入群聊')), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_ctx.currentFriend?.userID && _ctx.columnName === 'friend')
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("header", _hoisted_51, [
                    _createElementVNode("ul", _hoisted_52, [
                      _createElementVNode("h1", null, _toDisplayString(_ctx.currentFriend?.profile?.nick || _ctx.currentFriend?.userID), 1),
                      _createElementVNode("li", null, [
                        _hoisted_53,
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentFriend?.profile?.userID), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('TUIContact.个性签名')) + "：", 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentFriend?.profile?.selfSignature), 1)
                      ])
                    ]),
                    _createElementVNode("img", {
                      class: "avatar",
                      src: 
                _ctx.currentFriend?.profile?.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'
              ,
                      onerror: "this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
                    }, null, 8, _hoisted_54)
                  ]),
                  _createElementVNode("footer", _hoisted_55, [
                    _createElementVNode("button", {
                      class: "btn btn-default",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.enter(_ctx.currentFriend.userID, 'C2C')))
                    }, _toDisplayString(_ctx.$t('TUIContact.发送消息')), 1)
                  ])
                ]))
              : (_ctx.columnName === 'system')
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    (!_ctx.env.isH5)
                      ? (_openBlock(), _createElementBlock("header", _hoisted_57, [
                          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('TUIContact.系统通知')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_MessageSystem, {
                      isH5: _ctx.env.isH5,
                      data: _ctx.systemMessageList,
                      types: _ctx.types,
                      onApplication: _ctx.handleGroupApplication
                    }, null, 8, ["isH5", "data", "types", "onApplication"])
                  ]))
                : _renderSlot(_ctx.$slots, "default", { key: 4 }, undefined, true)
        ], 512), [
          [_vShow, !!_ctx.currentGroup?.groupID || _ctx.columnName === 'system' || !_ctx.env.isH5]
        ])
      ], 2)
    ]),
    _: 3
  }, 8, ["onBeforeLeave"]))
}